// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/users/plugins

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function ElementAccountSubscriptionList(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'ElementAccountSubscriptionList',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 10.5a4.5 4.5 0 113.695-7.07l-1.82 1.82H12V1.125l-1.232 1.232A6 6 0 106 12v-1.5zm-.375-6.375v-.75h.75v.75H7.5v.75H5.625a.375.375 0 100 .75h.75a1.125 1.125 0 010 2.25v.75h-.75v-.75H4.5v-.75h1.875a.375.375 0 100-.75h-.75a1.125 1.125 0 010-2.25z',
      fill: 'currentColor',
    })
  );
}
